// import { INDIVIDUAL_RECORD_TYPE, GAME_RECORD_SPAN } from '../../constants';

export function assembleBasePerformanceFilter(filterState) {
  let filter = {};

  if (filterState.years?.length > 0) {
    filter.tournament = {
      OR: filterState.years.map(y => ({
        tournament_date_gt: { year: y, month: 9, day: 1 },
        tournament_date_lt: { year: y + 1, month: 8, day: 31 }
      }))
    };
  }

  if (filterState.questionSets?.length > 0) {
    filter.tournament = {
      ...filter.tournament,
      questionSet: {
        id_in: filterState.questionSets
      }
    };
  }

  if (filterState.difficulties?.length > 0) {
    filter.tournament = {
      ...filter.tournament,
      questionSet: {
        ...filter.tournament?.questionSet,
        difficulty: {
          id_in: filterState.difficulties
        }
      }
    };
  }

  if (filterState.tournamentType) {
    filter.tournament = {
      ...filter.tournament,
      type: filterState.tournamentType
    };
  }

  if (filterState.setType === true || filterState.setType === false) {
    filter.tournament = {
      ...filter.tournament,
      questionSet: {
        ...filter.tournament?.questionSet,
        is_subject: filterState.setType
      }
    };
  }

  return filter;
}

export function assemblePlayerPerformanceFilter(filterState) {
  let filter = assembleBasePerformanceFilter(filterState);

  if (filterState.winLoss === true || filterState.winLoss === false) {
    filter.teamPerformance = { won: filterState.winLoss };
  }

  return filter;
}

export function assembleTeamPerformanceFilter(filterState) {
  let filter = assembleBasePerformanceFilter(filterState);

  if (filterState.winLoss === true || filterState.winLoss === false) {
    filter.won = filterState.winLoss;
  }

  return filter;
}

export function assembleGameFilter(filterState) {
  return {};
}

export function filterStateToQueryString(filterState) {
  let queryString = "";

  for (let prop in filterState) {
    if (Array.isArray(filterState[prop])) {
      for (let item of filterState[prop]) queryString += `&${prop}=${item}`;
    } else {
      queryString += `&${prop}=${filterState[prop]}`;
    }
  }

  return queryString;
}

export function queryStringToFilterState(queryString) {
  let searchParams = new URLSearchParams(queryString);
  let filterState = {};

  if (searchParams.getAll("difficulties"))
    filterState.difficulties = searchParams
      .getAll("difficulties")
      .map(d => parseInt(d));
  if (searchParams.getAll("questionSets"))
    filterState.questionSets = searchParams
      .getAll("questionSets")
      .map(d => parseInt(d));
  if (searchParams.getAll("years"))
    filterState.years = searchParams.getAll("years").map(d => parseInt(d));
  if (searchParams.get("winLoss"))
    filterState.winLoss = searchParams.getAll("winLoss") === "true";
  if (searchParams.get("tournamentType"))
    filterState.tournamentType = searchParams.get("tournamentType");
  if (searchParams.get("setType"))
    filterState.setType = searchParams.get("setType") === "true";

  return filterState;
}

export function getRecordTitleFromSort(span, orderBy, order) {
  let capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  let sortWord = order === "desc" ? "Most" : "Fewest";
  let orderByString = "";

  if (
    orderBy === "pp20tuh" ||
    orderBy === "ppb" ||
    orderBy === "winning_percentage"
  ) {
    sortWord = order === "desc" ? "Best" : "Worst";
    orderBy =
      orderBy === "pp20tuh" || orderBy === "ppb"
        ? orderBy.toUpperCase()
        : orderBy;
  }

  orderBy
    .split("_")
    .forEach(w => (orderByString += `${capitalizeFirstLetter(w)} `));

  return `${sortWord} ${orderByString}${
    span ? " in a " : ""
  }${capitalizeFirstLetter(span)}`;
}

export function setUrlFromFilterAndSort(filter, { order, orderBy }) {
  window.history.replaceState(
    null,
    null,
    `${
      window.location.pathname
    }?order=${order}&orderBy=${orderBy}${filterStateToQueryString(filter)}`
  );
}
